import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import DocumentLightbox from "../../components/DocumentLightbox";

const Kyc2 = ({ customerDeet }: any) => {
  const [copyMail, setCopyMail] = useState<boolean>(false);
  const [copyBvnNo, setCopyBvnNo] = useState<boolean>(false);
  const [copyNumber, setCopyNumber] = useState<boolean>(false);
  const [preview, setPreview] = useState<{ url: string; title: string } | null>(
    null
  );

  const kyc2 = customerDeet?.kyc2;
  const kyc2Data = kyc2?.data ?? {};
  const kyc1Data = customerDeet?.kyc1?.data ?? {};
  const smile = customerDeet?.kyc1?.smile_id_data;
  const govId = kyc2Data?.governmentID;
  const proof = kyc2Data?.proofOfAddress;
  const livenessUrl = kyc2Data?.livelinessCheck?.imageURL;
  const photoFromKyc1 = smile?.imageUrl;

  const bvn =
    kyc1Data?.bvn ?? smile?.idNumber ?? customerDeet?.userId?.kyc2?.data?.bvn;
  const email = customerDeet?.userId?.email?.address ?? "";
  const firstName =
    kyc1Data?.firstName ??
    smile?.firstName ??
    customerDeet?.userId?.profile?.firstName ??
    "";
  const lastName =
    kyc1Data?.lastName ??
    smile?.lastName ??
    customerDeet?.userId?.profile?.lastName ??
    "";
  const phone =
    kyc1Data?.phoneNumber ??
    smile?.phoneNumber ??
    customerDeet?.userId?.phone?.number ??
    "";
  const dob = smile?.dob ?? "";

  const statusLabel =
    kyc2?.status === "success" ||
    kyc2?.status === "VERIFIED" ||
    kyc2?.status === "approved"
      ? "Completed"
      : kyc2?.status === "rejected" || kyc2?.status === "Rejected"
      ? "Rejected"
      : kyc2?.status ?? "—";

  const statusColor =
    statusLabel === "Completed"
      ? "bg-[#0E2B1F] text-[#03C668] border-[#03C668]/30"
      : statusLabel === "Rejected"
      ? "bg-red-500/10 text-red-400 border-red-400/30"
      : "bg-[#CB9200]/10 text-[#F28A0F] border-[#F28A0F]/30";

  const proofAddressLine = proof?.houseAddress
    ? [
        proof.houseAddress.streetName,
        proof.houseAddress.apartmentNumber,
        proof.houseAddress.landmark,
        proof.houseAddress.city,
        proof.houseAddress.state,
        proof.houseAddress.postalCode,
      ]
        .filter(Boolean)
        .join(", ")
    : "";

  const copyTimeout = 3000;
  const onCopy = (setter: (v: boolean) => void) => {
    setter(true);
    setTimeout(() => setter(false), copyTimeout);
  };

  return (
    <div className="w-full bg-[#0D0D0D] p-4 sm:p-6 md:p-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h4 className="text-white font-sora font-bold text-[16px] sm:text-[18px]">
          Level 2 Verification
        </h4>
        <span
          className={`inline-flex items-center px-3 py-1.5 rounded-full text-[12px] font-semibold border ${statusColor} w-fit`}
        >
          {statusLabel?.toUpperCase()}
        </span>
      </div>

      <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Documents: Gov ID, Proof of address, Liveness/Photo */}
        <div className="lg:col-span-2 space-y-6">
          {govId && (govId.category || govId.number || govId.imageURL) && (
            <div className="rounded-xl border border-[#1C2227] bg-[#141414] p-5">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-[#0C84DA]/10 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-[#0C84DA]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="text-white font-sora font-bold text-[14px]">
                    Government ID
                  </h4>
                  <p className="text-[#869AA9] text-[12px]">
                    {govId.category}
                    {govId.number && ` · ${govId.number}`}
                  </p>
                </div>
              </div>
              {govId.imageURL && (
                <button
                  type="button"
                  onClick={() =>
                    setPreview({
                      url: govId.imageURL,
                      title: "Government ID",
                    })
                  }
                  className="w-full rounded-lg border border-[#1C2227] overflow-hidden bg-[#0D0D0D] flex justify-center items-center min-h-[160px] cursor-zoom-in hover:border-[#0C84DA]/50 transition-colors"
                >
                  <img
                    src={govId.imageURL}
                    alt="Government ID"
                    className="max-h-[200px] w-full object-contain"
                  />
                </button>
              )}
              {govId.imageURL && (
                <button
                  type="button"
                  onClick={() =>
                    setPreview({
                      url: govId.imageURL,
                      title: "Government ID",
                    })
                  }
                  className="mt-3 inline-flex items-center gap-2 text-[#0C84DA] text-[13px] font-medium hover:underline"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-4.35-4.35M11 8v6M8 11h6M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
                    />
                  </svg>
                  Enlarge
                </button>
              )}
            </div>
          )}

          {proof && (proof.houseAddress || proof.utilityBill) && (
            <div className="rounded-xl border border-[#1C2227] bg-[#141414] p-5">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-[#0C84DA]/10 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-[#0C84DA]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="text-white font-sora font-bold text-[14px]">
                    Proof of address
                  </h4>
                  {proof.utilityBill?.category && (
                    <p className="text-[#869AA9] text-[12px]">
                      {proof.utilityBill.category}
                    </p>
                  )}
                </div>
              </div>
              {proofAddressLine && (
                <p className="text-[#DEE1E6] text-[13px] leading-snug mb-4">
                  {proofAddressLine}
                </p>
              )}
              {proof.utilityBill?.imageURL && (
                <>
                  <button
                    type="button"
                    onClick={() =>
                      setPreview({
                        url: proof.utilityBill.imageURL,
                        title: "Proof of address",
                      })
                    }
                    className="w-full rounded-lg border border-[#1C2227] overflow-hidden bg-[#0D0D0D] flex justify-center items-center min-h-[140px] cursor-zoom-in hover:border-[#0C84DA]/50 transition-colors"
                  >
                    <img
                      src={proof.utilityBill.imageURL}
                      alt="Utility bill"
                      className="max-h-[180px] w-full object-contain"
                    />
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setPreview({
                        url: proof.utilityBill.imageURL,
                        title: "Proof of address",
                      })
                    }
                    className="mt-3 inline-flex items-center gap-2 text-[#0C84DA] text-[13px] font-medium hover:underline"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-4.35-4.35M11 8v6M8 11h6M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
                      />
                    </svg>
                    Enlarge
                  </button>
                </>
              )}
            </div>
          )}

          {(livenessUrl || photoFromKyc1) && (
            <div className="rounded-xl border border-[#1C2227] bg-[#141414] p-5">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-[#0C84DA]/10 flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-[#0C84DA]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="text-white font-sora font-bold text-[14px]">
                    {livenessUrl ? "Liveness check" : "Photo (from Level 1)"}
      </h4>
                  <p className="text-[#869AA9] text-[12px]">
                    {livenessUrl ? "Verification photo" : "Smile ID photo"}
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() =>
                  setPreview({
                    url: livenessUrl || photoFromKyc1,
                    title: livenessUrl ? "Liveness check" : "Smile ID photo",
                  })
                }
                className="rounded-lg border border-[#1C2227] overflow-hidden bg-[#0D0D0D] w-[140px] h-[140px] flex justify-center items-center cursor-zoom-in hover:border-[#0C84DA]/50 transition-colors"
              >
                <img
                  src={livenessUrl || photoFromKyc1}
                  alt={livenessUrl ? "Liveness" : "ID photo"}
                  className="w-full h-full object-cover"
                />
              </button>
            </div>
          )}
        </div>

        {/* Profile (from Level 1) - right column */}
        <div className="lg:col-span-1">
          <div className="rounded-xl border border-[#1C2227] bg-[#141414] p-5 sticky top-4">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-[#1C2227]">
              <div className="w-10 h-10 rounded-lg bg-[#0C84DA]/10 flex items-center justify-center">
                <svg
                  className="w-5 h-5 text-[#0C84DA]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
              <div>
                <h4 className="text-white font-sora font-bold text-[14px]">
                  Profile (Level 1)
            </h4>
                <p className="text-[#869AA9] text-[11px]">From KYC1 / Smile</p>
              </div>
            </div>
            <div className="space-y-3">
              {bvn && (
                <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                  <span className="text-[#869AA9] text-[12px]">BVN</span>
              <CopyToClipboard
                    text={bvn}
                    onCopy={() => onCopy(setCopyBvnNo)}
              >
                {copyBvnNo ? (
                      <span className="text-[11px] text-[#03C668] font-medium">
                    Copied
                  </span>
                ) : (
                      <span className="text-[#0C84DA] text-[12px] font-semibold cursor-pointer hover:underline">
                        {bvn}
                  </span>
                )}
              </CopyToClipboard>
          </div>
              )}
              {email && (
                <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                  <span className="text-[#869AA9] text-[12px]">Email</span>
            <CopyToClipboard
                    text={email}
                    onCopy={() => onCopy(setCopyMail)}
            >
              {copyMail ? (
                      <span className="text-[11px] text-[#03C668] font-medium">
                  Copied
                      </span>
                    ) : (
                      <span className="text-[#0C84DA] text-[12px] font-medium cursor-pointer hover:underline truncate max-w-[180px] text-right">
                        {email}
                      </span>
              )}
            </CopyToClipboard>
          </div>
              )}
              <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                <span className="text-[#869AA9] text-[12px]">First name</span>
                <span className="text-white text-[12px] font-medium">
                  {firstName || "—"}
                </span>
          </div>
              <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                <span className="text-[#869AA9] text-[12px]">Last name</span>
                <span className="text-white text-[12px] font-medium">
                  {lastName || "—"}
                </span>
          </div>
              {dob && (
                <div className="flex justify-between items-center py-2 border-b border-[#1C2227]/60">
                  <span className="text-[#869AA9] text-[12px]">Birthday</span>
                  <span className="text-white text-[12px] font-medium">
                    {dob}
                  </span>
          </div>
              )}
              <div className="flex justify-between items-center py-2">
                <span className="text-[#869AA9] text-[12px]">Phone</span>
                {phone ? (
              <CopyToClipboard
                    text={phone}
                    onCopy={() => onCopy(setCopyNumber)}
              >
                {copyNumber ? (
                      <span className="text-[11px] text-[#03C668] font-medium">
                    Copied
                  </span>
                ) : (
                      <span className="text-[#0C84DA] text-[12px] font-semibold cursor-pointer hover:underline">
                        {phone}
                  </span>
                )}
              </CopyToClipboard>
            ) : (
                  <span className="text-[#617889] text-[12px]">Not added</span>
            )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {preview && (
        <DocumentLightbox
          urls={[preview.url]}
          title={preview.title}
          onClose={() => setPreview(null)}
        />
      )}
    </div>
  );
};

export default Kyc2;
